<template>
  <div style="text-align:center">
    <div class="content">
      <!-- <img src="../assets/医生.jpg" style="width:100px;height:200px;"/> -->
      <div style="display:line-block">
        <div>
          <span class="code">401</span>
          <br/>
          <span class="tips">对不起，您无权限访问此内容</span>
        </div>
        <div>
          <div style="margin-top:20px">
            <el-button type="primary" class="font-size16" @click="gotoLogin('/')" >返回首页</el-button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="primary" class="font-size16"  @click="gotoLogin('/login')" plain>返回登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: `unauth`,
    data() {
        return {
            screenHeight: document.documentElement.clientHeight
        }
    },
    methods: {
        gotoLogin(link) {
            this.$router.push(link)
        }
    }
}
</script>

<style scoped>s
  p{
    line-height: 0;
    font-size: 300px;
    /* opacity: 0.5; */
  }
  .code{
    color: var(--primary-color, #009688);
    font-size: 200px;
    text-shadow:0px 15px 6px #ccc;
  }
  .content{
    width: 500px;
    position: relative;
    margin: 0 auto;
    margin-top: 200px;
  }
  .tips{
    font-size: 20px;
    /* color: black; */
  }
</style>



// WEBPACK FOOTER //
// src/components/Unauth.vue